const customLangs = {
    gb: {
        _name: 'English',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
    },
    ru: {
        _name: 'Русский',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
    },
    pl: {
        _name: 'Polski',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
    },
    cz: {
        _name: 'Čeština',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
    },
    de: {
        _name: 'Deutsch',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },

    },
    fr: {
        _name: 'Français',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },

    },
    es: {
        _name: 'Español',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },

    },
    dk: {
        _name: 'Dansk',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },

    },
    nl: {
        _name: 'Nederlandse taal',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },

    },
    sa: {
        _name: 'عربي',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },

    },
    it: {
        _name: 'Italiano',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },

    },
    sk: {
        _name: 'Slovak',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },

    },
    hu: {
        _name: 'Hungarian',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },

    },
    ro: {
        _name: 'Romanian',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },

    },
    ge: {
        _name: 'Georgia',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },

    },
    az: {
        _name: 'Azerbaijani',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },

    },
    tr: {
        _name: 'Türkçe',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },

    },
    rs: {
        _name: 'Srpski',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },

    },
    pt: {
        _name: 'Português',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
    },
    jp: {
        _name: '日本語',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
    },
    hr: {
        _name: 'Hrvatski',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },

    },
    kz: {
        _name: 'Қазақ тілі',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },

    },
    kg: {
        _name: 'Кыргыз тили',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },

    },
    cn: {
        _name: '中文',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },

    }
}

export default customLangs
